import { GET_ORG_LICENSE_SETTINGS } from '../../types'

const initialState = {
  general: {
    beginsAt: '',
    expiresAt: '',
    createdAt: '',
    maxUserCount: '',
    activeUserCount: ''
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ORG_LICENSE_SETTINGS: return {
      ...state,
      general: action.payload
    }
    default: return { ...state }
  }
}
